export const demoFlow = 'ab-testing-sign-up-demo-flows'
export const demoFlowVariant = {
  test: 'test',
  control: 'control',
}

// New signup page - SHAPE13
export const signupFlow: string = 'ab-test-new-signup-page'
export const signupVariantOptions: Record<string, string> = {
  minimal: 'minimal',
  marketing: 'marketing',
}
